import { Skeletons } from 'src/components/Skeletons';
import { CryptoPaymentMethod } from 'src/pages/AccountDeposit/components/Deposit/components/PaymentMethods/components/CryptoPaymentMethod';
import { CryptochillMethodsReturnType } from '../../types';

type CryptoChillMethodsProps = Pick<
  CryptochillMethodsReturnType,
  'selectedCryptoMethod' | 'isLoadingCryptoMethods' | 'cryptoMethods' | 'handleCryptoMethodSelect'
>;

export const CryptoChillMethods = ({
  cryptoMethods,
  handleCryptoMethodSelect,
  isLoadingCryptoMethods,
  selectedCryptoMethod
}: CryptoChillMethodsProps) => {
  return (
    <div className="flex gap-1 flex-wrap justify-center">
      {!isLoadingCryptoMethods ? (
        cryptoMethods?.map((method) => {
          const isSelected = selectedCryptoMethod?.name === method?.name;
          return (
            <CryptoPaymentMethod
              isSelected={isSelected}
              handleCryptoMethodSelect={handleCryptoMethodSelect}
              method={method}
              key={method.name}
            />
          );
        })
      ) : (
        <Skeletons className="w-[75px] 768:w-[85px] h-[80px]" count={8} />
      )}
    </div>
  );
};
